import axios, { AxiosError } from 'axios'
import { handleError } from '@/utils/httpClient'

export const fileApi = {

    async uploadDocument(file: any, config: any): Promise<any> {
        const formData = buildFormData(file, config)

        try {
            const response = await axios.post('file/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            return response.status === 200 ? response.data : null
        } catch (error) {
            return handleError(error as AxiosError)
        }
    },

    async downloadDocument(id: Number): Promise<void> {
        try {
            const response = await axios({
                url: `file/download/${id}`,
                method: 'GET',
                responseType: 'blob',
            })

            const contentDisposition = response.headers['content-disposition']
            const filename = parseFileName(contentDisposition)

            triggerBrowserDownload(response.data, filename)
        } catch (error) {
            console.error('Download failed:', error)
        }
    },
}

// --- Private helpers ---

function buildFormData(file: any, config: any): FormData {
    const formData = new FormData()

    for (const key in config) {
        if (Array.isArray(config[key])) {
            if (config[key].length > 0) {
                formData.append(key, config[key])
            }
        } else {
            formData.append(key, config[key])
        }
    }

    formData.append('file', file)
    return formData
}

function parseFileName(contentDisposition: string): string {
    const filenameStarRegex = /filename\*=(?:UTF-8'')?([^;]+)/i
    const filenameRegex = /filename="?([^;"]+)"?/i

    let match = contentDisposition.match(filenameStarRegex)
    if (match) {
        return decodeURIComponent(match[1].trim())
    }

    match = contentDisposition.match(filenameRegex)
    if (match) {
        return match[1].trim().replace(/^["']|["']$/g, '')
    }

    return 'WWS-translation-result'
}

function triggerBrowserDownload(data: Blob, filename: string): void {
    const href = window.URL.createObjectURL(data)
    const anchor = document.createElement('a')

    anchor.href = href
    anchor.download = filename
    document.body.appendChild(anchor)
    anchor.click()

    document.body.removeChild(anchor)
    window.URL.revokeObjectURL(href)
}